import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useRef, useCallback, useEffect } from 'react';
import { requestTimeout, clearRequestTimeout } from '@essentials/request-timeout';
import { canHover } from '@react-hook/hover';
import { useThrottleCallback } from '@react-hook/throttle';
var emptyArr = [],
    initialState = {
  x: null,
  y: null,
  pageX: null,
  pageY: null,
  clientX: null,
  clientY: null,
  screenX: null,
  screenY: null,
  elementWidth: null,
  elementHeight: null,
  isOver: false
};
export var useMousePosition = function useMousePosition() {
  var enterDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var leaveDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var fps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1],
      entered = useRef(false),
      element = useRef(null),
      timeout = useRef(null);

  var delay = useCallback(function (amt, fn) {
    if (!canHover) return;
    timeout.current !== null && clearRequestTimeout(timeout.current);

    if (amt) {
      timeout.current = requestTimeout(fn, amt);
    } else {
      fn();
    }
  }, emptyArr);

  var _onMove = useCallback(function (e) {
    if (canHover === false || entered.current === false) return;
    var clientX = e.clientX,
        clientY = e.clientY,
        screenX = e.screenX,
        screenY = e.screenY,
        pageX = e.pageX,
        pageY = e.pageY,
        rect = element.current.getBoundingClientRect();
    setState({
      x: pageX - rect.left - window.pageXOffset,
      y: pageY - rect.top - window.pageYOffset,
      pageX: pageX,
      pageY: pageY,
      clientX: clientX,
      clientY: clientY,
      screenX: screenX,
      screenY: screenY,
      elementWidth: rect.width,
      elementHeight: rect.height,
      isOver: true
    });
  }, emptyArr);

  var onMove = useThrottleCallback(_onMove, fps, true);
  var onEnter = useCallback(function (e) {
    return delay(enterDelay, function () {
      entered.current = true;
      onMove(e);
    });
  }, [enterDelay, delay]);
  var onLeave = useCallback(function () {
    return delay(leaveDelay, function () {
      entered.current = false;
      setState(initialState);
    });
  }, [leaveDelay, delay]);
  useEffect(function () {
    if (element.current !== null) {
      element.current.addEventListener('mouseenter', onEnter);
      element.current.addEventListener('mousemove', onMove);
      element.current.addEventListener('mouseleave', onLeave);
    }

    return function () {
      timeout.current !== null && clearRequestTimeout(timeout.current);
      timeout.current = null;

      if (element.current !== null) {
        element.current.removeEventListener('mouseenter', onEnter);
        element.current.removeEventListener('mousemove', onMove);
        element.current.removeEventListener('mouseleave', onLeave);
      }
    };
  }, [element.current, onEnter, onLeave, onMove]);
  return [element, state];
};
export default useMousePosition;